import React from 'react';

interface InfoIconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string;
}

const InfoIcon: React.FC<InfoIconProps> = ({ fillColor = '#666', ...props }) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 2.864a6.136 6.136 0 1 0 0 12.272A6.136 6.136 0 0 0 9 2.864ZM1.5 9a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Z"
      fill={fillColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 8.318c.377 0 .682.305.682.682v2.727a.682.682 0 0 1-1.364 0V9c0-.377.305-.682.682-.682ZM8.318 6.273c0-.377.305-.682.682-.682h.007a.682.682 0 1 1 0 1.364H9a.682.682 0 0 1-.682-.682Z"
      fill={fillColor}
    />
  </svg>
);

export default InfoIcon;